import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import useSWR from "swr";

const ShortLink = () => {
  const [searchParams] = useSearchParams();
  const linkParam = searchParams.get("c");
  const navigate = useNavigate();

  const { data, error } = useSWR(() => {
    if (!linkParam) {
      return null;
    }
    return `${process.env.REACT_APP_API}/content/full-link/${linkParam}/`;
  });
  useEffect(() => {
    if (error) {
      navigate("/");
    }
    if (data) {
      // console.log(data.original_url.substring(15, 50));
      // navigate(data.original_url);
      window.location.replace(data.original_url);
    }
  });

  return null;
};

export default ShortLink;
